// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__Jcc1L","content":"styles_content__1peWP","checkbox":"styles_checkbox__25Uv8","checkboxLabel":"styles_checkboxLabel__dQj9E"};